import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import Box from '@o2/ui/Box';
import Typography from '@o2/ui/Typography';

import { useSubheaderUtilityClasses } from './subheaderClasses';

export interface DescriptionProps {
  children: ReactNode;

  /**
   * Disable styling the passed children as secondary text.
   *
   * Defaults to false (= styles the children) if children is a string,
   * true otherwise (if you pass a ReactElement, for example, it will not be styled).
   *
   * Useful to override for example when composing the description from several `<span/>`s.
   */
  disableStyling?: boolean;
}

const Description: FC<DescriptionProps> = ({ children, disableStyling = typeof children !== 'string', ...props }) => {
  const utilityClasses = useSubheaderUtilityClasses();

  return (
    // TODO: get rid of !important
    <Box
      width="100%"
      order={{ xs: 2, md: 3 }}
      marginLeft="0 !important"
      className={clsx(utilityClasses.description)}
      {...props}
    >
      {disableStyling ? children : <Typography color="textSecondary">{children}</Typography>}
    </Box>
  );
};

Description.displayName = 'Subheader.Description';

export default Description;
